export enum ISP_STEP_NAME {
  /** 選擇方案（§3.6.1 步驟重排，方案提前）*/
  SELECT_PLAN = 'ISPInstall_step-select-plan',
  /** 輸入社區（查社區 + 社區方案重選）*/
  SEARCH_N_PICK = 'ISPInstal_step-search-n-pick',
  /** 填寫資訊 */
  INFO_FORM = 'ISPInstall_step-info-form',
  /** 完成申請 */
  FINISH = 'ISPInstall_step-finish'
}